(function () {
  'use strict';

  function ordersFactory (apiFactory, paymentFactory, $http) {
    const factory = {};

    function getOrders () {
      const filters = {
        'filterKey': 'status',
        'filterValue': 'PLACED',
        'filterExclude': true
      };

      return apiFactory.getOrders.get(filters).$promise;
    }

    function getOrderById (id) {
      const data = {
        orderId: id
      };

      return apiFactory.getOrderById.get(data).$promise;
    }

    function restructureToDisplay (order) {
      if (order) {
        order.pricing = paymentFactory.extractCalculatedPrice(order.pricing);
      }

      return order;
    }

    function cancelOrder (orderId) {
      const data = {
        orderId: orderId
      };

      return apiFactory.cancelOrder.post(data).$promise;
    }

    factory.getOrders = getOrders;
    factory.getOrderById = getOrderById;
    factory.restructureToDisplay = restructureToDisplay;
    factory.cancelOrder = cancelOrder;

    return factory;
  }

  angular.module('web2print.orders')
    .factory('ordersFactory', ordersFactory);
})();
